// canMakePaymentsはsafariでしか提供されていないのでユーザエージェントで判断
export const isAppleDeviceUserAgent = (): boolean => {
  const userAgent = navigator.userAgent;
  const SUPPORTED_MOBILE_USER_AGENT = ['iPhone', 'iPad', 'iPod'];

  if (
    userAgent.includes('Macintosh') ||
    SUPPORTED_MOBILE_USER_AGENT.some((ua) => userAgent.includes(ua))
  ) {
    return true;
  }

  return false;
};

/**
 * ユーザのデバイスがApplePayをサポートしているかどうかを示します
 * @returns boolean
 */
export const isAvailableApplePay = ((): boolean => {
  if (
    (typeof ApplePaySession !== 'undefined' &&
      ApplePaySession.canMakePayments()) ||
    isAppleDeviceUserAgent()
  ) {
    return true;
  }

  return false;
})();
